var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "order-return-summary flex flex-auto flex-col",
    },
    [
      _c("div", { staticClass: "title" }, [
        _vm._v(
          "\n    Replacement #" +
            _vm._s(_vm.replacementId) +
            " has been created.\n  "
        ),
      ]),
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _vm._v(" "),
      _vm.needsReturnLabel
        ? _c("div", { staticClass: "description" }, [
            _vm._v(
              "\n    Replacement has been created. Customer will receive 2 emails, 1) "
            ),
            _c("br"),
            _vm._v(
              "\n    replacement device confirmation and shipping info, and 2) a return label"
            ),
            _c("br"),
            _vm._v("\n    to return their old device.\n  "),
          ])
        : _c("div", { staticClass: "description" }, [
            _vm._v(
              "\n    Replacement has been created. Customer will receive an email for replacement device confirmation and shipping info.\n  "
            ),
          ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("div", { staticClass: "return-summary" }, [
        _c(
          "div",
          { staticClass: "return-customer-details" },
          [
            _c(
              "el-card",
              {
                attrs: {
                  shadow: "never",
                  "body-style": "margin: 0px !important;",
                },
              },
              [
                _c(
                  "el-table",
                  {
                    staticClass: "table-hover",
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.summary,
                      "show-header": false,
                      "row-class-name": "table-hover",
                      "cell-class-name": "table-hover",
                      "highlight-current-row": false,
                    },
                  },
                  [
                    _c(
                      "el-table-column",
                      { attrs: { type: "expand" } },
                      [
                        [
                          _c("div", { staticClass: "flex flex-col" }, [
                            _c("div", { staticClass: "summary-header" }, [
                              _vm._v(
                                "\n                  Created On: " +
                                  _vm._s(_vm.createdOn) +
                                  "\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("br"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "flex flex-col" }, [
                            _c("div", { staticClass: "summary-header" }, [
                              _vm._v(
                                "\n                  Old Product\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticStyle: { "margin-top": "8px" } },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.device.profile.product.description
                                    )
                                ),
                                _c("br"),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticStyle: {
                                      color: "#6E6E6E",
                                      margin: "0 !important",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                    MAC ID: " +
                                        _vm._s(_vm.device.mac_address) +
                                        "\n                  "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticStyle: {
                                      color: "#6E6E6E",
                                      margin: "0 !important",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm.device.profile.color) +
                                        "\n                  "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("el-divider"),
                          _vm._v(" "),
                          _c("div", { staticClass: "flex flex-col" }, [
                            _c("div", { staticClass: "summary-header" }, [
                              _vm._v(
                                "\n                  Replacement Product\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticStyle: { "margin-top": "8px" } },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.replacementProduct.product.description
                                    )
                                ),
                                _c("br"),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticStyle: {
                                      color: "#6E6E6E",
                                      margin: "0 !important",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm.replacementProduct.color) +
                                        "\n                  "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.replacementProduct.estimated_delivery
                                  ? _c(
                                      "p",
                                      {
                                        staticClass: "estimated-delivery",
                                        staticStyle: { margin: "0 !important" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.replacementProduct
                                                .estimated_delivery
                                            ) +
                                            "\n                  "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("el-divider"),
                          _vm._v(" "),
                          _c("div", { staticClass: "flex flex-col" }, [
                            _c("div", { staticClass: "summary-header" }, [
                              _vm._v(
                                "\n                  Replacement Reason\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticStyle: { "margin-top": "8px" } },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.selectedName)
                                ),
                                _c("br"),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("el-divider"),
                          _vm._v(" "),
                          _c("div", { staticClass: "flex flex-col" }, [
                            _c("div", { staticClass: "summary-header" }, [
                              _vm._v(
                                "\n                  Other Info\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "flex flex-row",
                                staticStyle: { "margin-top": "8px" },
                              },
                              [
                                _c("div", { staticClass: "flex-1" }, [
                                  _vm._v(
                                    "\n                    Place of purchase\n                  "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", [_vm._v(_vm._s(_vm.retailer))]),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "flex flex-row" }, [
                              _c("div", { staticClass: "flex-1" }, [
                                _vm._v(
                                  "\n                    Date of initial setup\n                  "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c("time-zone-formatter", {
                                    attrs: {
                                      "output-format": "DD MMMM, YYYY",
                                      "current-time": _vm.firstSetupDate,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("el-divider"),
                          _vm._v(" "),
                          _c("div", { staticClass: "flex flex-col" }, [
                            _c("div", { staticClass: "summary-header" }, [
                              _vm._v(
                                "\n                  Customer info\n                "
                              ),
                            ]),
                            _c("br"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "flex flex-col" }, [
                            _c("div", { staticClass: "flex flex-row" }, [
                              _c("div", { staticClass: "flex-1" }, [
                                _vm._v(
                                  "\n                    Name\n                  "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  _vm._s(_vm.customer.first_name) +
                                    " " +
                                    _vm._s(_vm.customer.last_name)
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "flex flex-row" }, [
                              _c("div", { staticClass: "flex-1" }, [
                                _vm._v(
                                  "\n                    Phone Number\n                  "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(_vm._s(_vm.customer.phone_number)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "flex flex-row" }, [
                              _c("div", { staticClass: "flex-1" }, [
                                _vm._v(
                                  "\n                    Email\n                  "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [_vm._v(_vm._s(_vm.customer.email))]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "flex flex-row",
                                staticStyle: { "margin-top": "20px" },
                              },
                              [
                                _c("div", { staticClass: "flex-1" }, [
                                  _vm._v(
                                    "\n                    Street\n                  "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    _vm._s(_vm.address.address1) +
                                      " " +
                                      _vm._s(_vm.address.address2)
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "flex flex-row" }, [
                              _c("div", { staticClass: "flex-1" }, [
                                _vm._v(
                                  "\n                    City\n                  "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [_vm._v(_vm._s(_vm.address.city))]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "flex flex-row" }, [
                              _c("div", { staticClass: "flex-1" }, [
                                _vm._v(
                                  "\n                    State/province/area\n                  "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [_vm._v(_vm._s(_vm.address.state))]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "flex flex-row" }, [
                              _c("div", { staticClass: "flex-1" }, [
                                _vm._v(
                                  "\n                    Zip code\n                  "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [_vm._v(_vm._s(_vm.address.zip_code))]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "flex flex-row" }, [
                              _c("div", { staticClass: "flex-1" }, [
                                _vm._v(
                                  "\n                    Country\n                  "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [_vm._v(_vm._s(_vm.address.country))]),
                            ]),
                          ]),
                        ],
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("el-table-column", {
                      staticStyle: { "padding-left": "20px" },
                      attrs: { label: "Replacement Summary", prop: "title" },
                    }),
                    _c("label", [
                      _vm._v("Replacement Summary\n              "),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }